const PersonWithPlusIcon = ({ className, ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <circle
                cx="10"
                cy="8"
                r="3.25"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8759 20H4.17653C3.67361 18.5 3.87572 14 9.87587 14"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M14 14L20 14" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M17 11L17 17" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
}

export default PersonWithPlusIcon
